(function () {
    'use strict';

    function MwSearchInputController(
        $scope,
        $element,
        ContactManagerNavigationService,
        InfluencerContactService,
        $translate,
        $timeout
    ) {
        var suggestList = $element.find('#suggest-list'),
            SUGGEST_DEBOUNCE_MS = 300,
            COMMA_KEYCODE = 188,
            TAB_KEYCODE = 9,
            ENTER_KEYCODE = 13,
            clickingSuggestList = false;

        this.$onInit = function $onInit() {
            this.whiteframe = -1;
            this.$translate = $translate;
            this.searchText = this.searchText || '';
            this.contacts = [];
            this.sources = [];
            this.autoSuggestPromise = null;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.InfluencerContactService = InfluencerContactService;
            this.showAutoSuggestAfterSearch = true;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.lastSearch = undefined;
            this.lastSearchType = undefined;
            this.hideSearchBarLoader = true;
            //chips stuff
            this.readOnly = false;
            this.removable = true;
            this.addOnBlur = false;
            this.customSeparatorKeys = [COMMA_KEYCODE, TAB_KEYCODE, ENTER_KEYCODE];

            // IE does not have event.relatedTarget on 'blur', so we need to track if we are clicking into the autosuggest list in this way.
            suggestList.on('mousedown', function onClick() {
                clickingSuggestList = true;
            });

            suggestList.on('mouseup', function onClick() {
                clickingSuggestList = false;
            });

            this.searchTypeOptions.forEach((searchType)=> {
                if(searchType.selected) {
                    this.selectedSearchType = searchType.type;
                }
            });

            if (this.searchText.length > 0 && this.searchChips.length > 0) {
                var chipExists = this.searchChips.some(function(searchChipObject) {
                    return (searchChipObject.type === 'standard' && (searchChipObject.value.toLowerCase() === this.searchText.toLowerCase()));
                }.bind(this));
                if (chipExists) {
                    this.searchText = '';
                }
            }
        };

        this.$onDestroy = function onDestroy() {
            suggestList.off('mousedown');
            suggestList.off('mouseup');

            $timeout.cancel(this.autoSuggestPromise);
        };

        this.onFocus = function onFocus() {
            this.whiteframe = 4;
            this.hasFocus = true;

            if (this.searchText && this.searchText.length > 1) {
                this.showAutoSuggestAfterSearch = true;
                this.getByContactAndSourceSuggest(this.searchText);
            }
        };

        this.onBlur = function onBlur() {
            this.whiteframe = -1;

            // if we clicked an auto-suggest option,
            // it will cause triggerSearch.
            // which will hide this after handling the click.
            // otherwise we hide it before the click action & nothing happens...
            if(!clickingSuggestList) {
                if (this.searchText.length > 0) {
                    this.addChip(this.searchText);
                }
                this.hasFocus = false;
                this.hideAutoSuggest();
            }
        };

        this.getByContactAndSourceSuggest = function getByContactAndSourceSuggest(searchText) {
            var searchType = this.isContactSearch ? 'contact' : 'source';

            // cache last query
            if(searchText !== this.lastSearch || searchType !== this.lastSearchType) {
                this.hideSearchBarLoader = false;
                return this.InfluencerContactService.getByContactAndSourceSuggest(searchText).then(function (response) {
                    this.lastSearch = searchText;
                    this.lastSearchType = searchType;
                    this.contacts = [];
                    this.sources = [];

                    if (searchType === 'contact') {
                        for (var i = 0; i < response.contacts.length; i++) {
                            var currentContact = response.contacts[i];
                            if (currentContact.sourceSnippets) {
                                currentContact.sourceList = currentContact.sourceSnippets
                                    .map(function (element) {
                                        return element.name;
                                    })
                                    .join(', ');
                            }
                        }
                        this.contacts = response.contacts;
                    }
                    else if (searchType === 'source') {
                        this.sources = response.sources;
                    }

                    if(this.showAutoSuggestAfterSearch){
                        this.showAutoSuggest();
                    } else {
                        this.showAutoSuggestAfterSearch = true;
                    }

                    this.hideSearchBarLoader = true;

                    }.bind(this));
            } else {
                if(this.showAutoSuggestAfterSearch){
                    this.showAutoSuggest();
                }
            }
        };

        this.hideAutoSuggest = function hideAutoSuggest() {
            if(!$timeout.cancel(this.autoSuggestPromise)){
                this.showAutoSuggestAfterSearch = false;
            }

            suggestList.hide();
            this.autoSuggestToggle({isVisible: false});
        };

        this.showAutoSuggest = function showAutoSuggest() {
            suggestList.show();
            this.autoSuggestToggle({isVisible: true});
        };

        this.goToSource = function goToSource(sourceId) {
            this.clearAndUpdateSearchText();

            this.ContactManagerNavigationService.goToSourceDetailView(sourceId);
        }.bind(this);

        this.goToContact = function goToContact(contactId) {
            this.clearAndUpdateSearchText();

            this.ContactManagerNavigationService.goToProfileView(contactId);
        }.bind(this);

        this.searchTextChanged = function searchTextChanged(searchText) {
            if(this.onTextChange) {
                this.onTextChange({searchText: searchText});
            }

            if(searchText) {
                // debounce this in a way that can be cancelled,
                // for when we hide the suggestions (ex. on-enter, blur)
                $timeout.cancel(this.autoSuggestPromise);
                if(searchText.length > 1 && this.searchChips.length === 0) {
                    this.showAutoSuggestAfterSearch = true;
                    this.autoSuggestPromise = $timeout(function() {
                        this.getByContactAndSourceSuggest(searchText);
                    }.bind(this), SUGGEST_DEBOUNCE_MS);
                } else if (searchText.length <= 1) {
                    this.hideSearchBarLoader = true;
                }
            } else {
                // if we have no searchText, but clicked an auto-suggest that means we built a chip.
                // in order to trigger the new search we need to keep auto-suggest open for later events
                if(!clickingSuggestList) {
                    this.hideAutoSuggest();
                }
            }
        };

        this.clickedInfluencers = function clickedInfluencers() {
            this.selectedSearchType = this.searchTypeOptions[0].type;

            this.selectInfluencers();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedRelevantInfluencers = function clickedRelevantInfluencers() {
            this.selectedSearchType = this.searchTypeOptions[1].type;

            this.selectRelevantInfluencers();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedSources = function clickedSources() {
            this.selectedSearchType = this.searchTypeOptions[2].type;

            this.selectSources();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.clickedRelevantSources = function clickedRelevantSources() {
            this.selectedSearchType = this.searchTypeOptions[3].type;

            this.selectRelevantSources();
            this.hideAutoSuggest();

            if (this.searchText.length > 0) {
                this.addChip(this.searchText);
            }
        };

        this.addChip = function addChip(chip, executeSearch) {
            var chipExists = this.searchChips.some(function(searchChipObject) {
                return (searchChipObject.type === 'standard' && (searchChipObject.value.toLowerCase() === chip.toLowerCase()));
            });

            if(chipExists) {
                this.searchChips.pop();
            } else {
                // md-chip natually does not add a chip object to the array
                if (this.searchChips[this.searchChips.length - 1] === chip) {
                    this.searchChips.pop();
                }

                this.searchChips[this.searchChips.length] = {
                    type: 'standard',
                    value: chip,
                    display: chip
                };

                if (!this.getSearchType()) {
                    this.setSearchType();
                    this.selectedSearchType = this.searchTypeOptions[0].type;
                }

                if (typeof executeSearch === 'undefined') {
                    executeSearch = true;
                }

                this.addChipCallback({executeSearch: executeSearch});

                // the call to "clearAndUpdateSearchText" needs to occur after "addChipCallback", due to some dependencies in the search controller
                // otherwise the relevant searches break down, and do not return proper results
                if (this.searchText === chip) {
                    this.clearAndUpdateSearchText();
                }
            }
        };

        this.removeChip = function removeChio(chip) {
            this.removeChipCallback({removedChip: chip});
        };

        this.clearAndUpdateSearchText = function clearAndUpdateSearchText() {
            this.searchText = '';
            this.searchTextChanged(this.searchText);
        };
    }

    angular
        .module('MW.ContactManager.MwSearchInput', ['MW.ContactManager.ContactManagerNavigationService', 'MW.Framework.InfluencerContactService'])
        .component('mwSearchInput', {
            bindings: {
                search: '&',
                searchText: '<',
                isContactSearch: '=',
                getSearchType: '&',
                setSearchType: '&',
                searchTypeOptions: '=',
                selectInfluencers: '&',
                selectRelevantInfluencers: '&',
                selectSources: '&',
                selectRelevantSources: '&',
                placeholder: '<',
                sourcePlaceholder: '<',
                secondaryPlaceholder: '<',
                onTextChange: '&',
                autoSuggestToggle: '&',
                addChipCallback: '&',
                removeChipCallback: '&',
                searchChips: '=',
                clearChips: '&',
                isV2: '='
            },
            controller: [
                '$scope',
                '$element',
                'ContactManagerNavigationService',
                'InfluencerContactService',
                '$translate',
                '$timeout',
                MwSearchInputController
            ],
            template: `
            <div class="search-input-wrapper" md-whiteframe="{{$ctrl.whiteframe}}" ng-class="{borderless: ($ctrl.whiteframe > -1)}">
            <div class="search-input-container" layout="row">
                <md-icon ng-if="$ctrl.searchChips.length < 1" class="search" md-svg-icon="action:ic_search_24px"></md-icon>
                <md-icon ng-if="$ctrl.searchChips.length >= 1" ng-click="$ctrl.clearChips()" class="clear" md-svg-icon="content:ic_clear_24px"></md-icon>
                <md-chips
                    secondary-placeholder=""
                    ng-model="$ctrl.searchChips"
                    readonly="$ctrl.seachChips.length > $ctrl.maxChips"
                    md-separator-keys="$ctrl.customSeparatorKeys"
                    md-removable="$ctrl.removable"
                    md-on-add="$ctrl.addChip($chip)"
                    md-add-on-blur=false
                    md-on-remove="$ctrl.removeChip($chip)"
                    class="md-primary"
                    flex="100">
                    <md-chip-template>
                      <span>{{$chip.display}}</span>
                    </md-chip-template>
                    <input
                        type="text"
                        ng-model="$ctrl.searchText"
                        ng-change="$ctrl.searchTextChanged($ctrl.searchText)"
                        ng-class="{'extra-large': ($ctrl.searchChips.length === 0), 'large': ($ctrl.searchChips.length === 1)}"
                        tabindex="0"
                        placeholder="{{$ctrl.searchChips.length > 1 ? '' : ($ctrl.searchChips.length === 0 ? ($ctrl.isContactSearch ? $ctrl.placeholder : $ctrl.sourcePlaceholder) : $ctrl.secondaryPlaceholder)}}"
                        ng-focus="$ctrl.onFocus()"
                        ng-blur="$ctrl.onBlur()"
                        on-enter-action="$ctrl.onEnterAction()">
                </md-chips>
            </div>
            <md-progress-linear md-mode="indeterminate" ng-disabled="$ctrl.hideSearchBarLoader"></md-progress-linear>

            <md-content layout="row" class="list">
                <md-list flex="100" id="suggest-list" ng-show="(($ctrl.searchText.length > 1 && $ctrl.searchChips.length === 0) && $ctrl.hasFocus)">
                    <!-- Search shortcuts -->
                    <md-list-item ng-if="$ctrl.contacts.length && $ctrl.isContactSearch" ng-click="$ctrl.clickedInfluencers()" class="suggestionButton">
                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>
                        <span>
                            <span translate>icm-search__auto-suggest--all-influencers-named</span>
                            <span class="highlight">{{$ctrl.searchText}}</span>
                        </span>
                    </md-list-item>
                    <md-list-item ng-if="$ctrl.isContactSearch" ng-click="$ctrl.clickedRelevantInfluencers()">
                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>
                        <span>
                            <span translate>icm-search__auto-suggest--all-influencers-who-write-about</span>
                            <span class="highlight">{{$ctrl.searchText}}</span>
                        </span>
                    </md-list-item>
                    <md-list-item ng-if="$ctrl.sources.length && !$ctrl.isContactSearch" ng-click="$ctrl.clickedSources()" class="suggestionButton">
                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>
                        <span>
                            <span translate>icm-search__auto-suggest--all-sources-named</span>
                            <span class="highlight">{{$ctrl.searchText}}</span>
                        </span>
                    </md-list-item>
                    <md-list-item ng-if="!$ctrl.isContactSearch" ng-click="$ctrl.clickedRelevantSources()">
                        <md-icon class="md-avatar-icon search" md-svg-icon="action:ic_search_24px"></md-icon>
                        <span>
                            <span translate>icm-search__auto-suggest--all-sources-writing-about</span>
                            <span class="highlight">{{$ctrl.searchText}}</span>
                        </span>
                    </md-list-item>
                    <!-- Separator -->
                    <md-list-item class="separator" ng-if="$ctrl.contacts.length || $ctrl.sources.length">
                        <span translate>icm-search__auto-suggest--top-results</span>
                    </md-list-item>

                    <!-- Contacts -->
                    <md-list-item ng-repeat="item in $ctrl.contacts" ng-click="$ctrl.goToContact(item.id)" class="md-3-line suggestionButton" ng-if="$ctrl.isContactSearch">
                        <md-icon class="md-avatar-icon contact" md-svg-icon="meltwater:person"></md-icon>
                        <div class="md-list-item-text" layout="column" layout-align="center none">
                            <span class="line-one" md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.firstName}} {{item.middleName}} {{item.lastName}}</span>
                            <span class="line-two">
                                <span ng-if="item.title">{{item.title}}</span>
                                <span ng-if="item.title && item.sourceList">&middot;</span>
                                <span ng-if="item.sourceList">{{item.sourceList}}</span>
                            </span>
                            <span class="line-three">
                                <span class="line-three" ng-if="item.city.length">{{item.city}}</span><span class="line-three" ng-if="item.stateOrProvince.length"><span class="line-three" ng-if="item.city.length">, </span>{{item.stateOrProvince}}</span><span class="line-three" ng-if="item.country.length"><span class="line-three" ng-if="item.city.length || item.stateOrProvince.length">, </span>{{item.country}}</span>
                            </span>
                        </div>
                        <md-icon class="md-secondary" md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>
                    </md-list-item>

                    <!-- Sources -->
                    <md-list-item ng-repeat="item in $ctrl.sources" ng-click="$ctrl.goToSource(item.id)" class="md-3-line suggestionButton" ng-if="$ctrl.isContactSearch===false">
                        <md-icon class="md-avatar-icon source" md-svg-icon="communication:ic_business_24px"></md-icon>
                        <div class="md-list-item-text" layout="column">
                            <span class="line-one" md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.name}}</span>
                            <span class="line-three">
                                <span class="line-three" ng-if="item.city.length">{{item.city}}</span><span class="line-three" ng-if="item.stateOrProvince.length"><span class="line-three" ng-if="item.city.length">, </span>{{item.stateOrProvince}}</span><span class="line-three" ng-if="item.country.length"><span class="line-three" ng-if="item.city.length || item.stateOrProvince.length">, </span>{{item.country}}</span>
                            </span>
                        </div>
                        <md-icon class="md-secondary" md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>
                    </md-list-item>
                </md-list>
            </md-content>
            </div>
            `
        });
}());
